/* eslint-disable no-console */
export const GET_CITY_FOR_POSTAL_CODE = 'GET_CITY_FOR_POSTAL_CODE';

/** @namespace Pwa/Store/PostalCodeLookUp/Action/getPostalCodeLookUp */
export const getPostalCodeLookUp = (data) => ({
    type: GET_CITY_FOR_POSTAL_CODE,
    data
});
